module.exports = ".member-name {\r\n  color: cornflowerblue;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/clubprogram-reports/components/donation-report/donation-report.component.css
// module id = ./src/app/shared/clubprogram-reports/components/donation-report/donation-report.component.css
// module chunks = main